<template>
    <i id="backtotop" @click="scrollToTop" :class="{center:position==='center'}" >
        <div class="backtotop-arrow" ></div>
    </i>
</template>

<script>
    Math.easeInOutQuad = function (t, b, c, d) {
        t /= d/2;
        if (t < 1) return c/2*t*t + b;
        t--;
        return -c/2 * (t*(t-2) - 1) + b;
    };
    export default {
        name: "backtotop",
        computed: {},
        props:{
            position: {type:String}
        },
        methods: {
            scrollToTop() {
                let element = document.documentElement;
                let to = 0;
                let duration = 550;
                var start = element.scrollTop,
                        change = to - start,
                        currentTime = 0,
                        increment = 20;

                var animateScroll = function(){
                    currentTime += increment;
                    var val = Math.easeInOutQuad(currentTime, start, change, duration);
                    //element.scrollTop = val;
                    window.scrollTo(0, parseInt(val));
                    if(currentTime < duration) {
                        setTimeout(animateScroll, increment);
                    }
                };
                animateScroll();
            }

        }
    }
</script>

<style scoped>
    #backtotop {
        position: fixed;
        bottom: 10px;
        right: 10px;
        height: 56px;
        width: 56px;
        background: rgba(61, 66, 72, 0.3);
        -moz-border-radius: 56px;
        -webkit-border-radius: 56px;
        border-radius: 56px;
        cursor: pointer;
        z-index: 60;
    }
    #backtotop.center{
        right:auto;
        left:50%;
        margin-left:-28px;

    }
    #backtotop .backtotop-arrow::before, #backtotop .backtotop-arrow::after {
        content: '';
        position: absolute;
        top: 25px;
        height: 3px;
        width: 12px;
        background: #fff;
    }

    #backtotop .backtotop-arrow::after {
        -moz-transform: rotate(-45deg);
        -ms-transform: rotate(-45deg);
        -webkit-transform: rotate(-45deg);
        transform: rotate(-45deg);
        -moz-border-radius-bottomleft: 3px;
        -webkit-border-bottom-left-radius: 3px;
        border-bottom-left-radius: 3px;
        -moz-border-radius-topleft: 3px;
        -webkit-border-top-left-radius: 3px;
        border-top-left-radius: 3px;
        left: 19px;
    }

    #backtotop .backtotop-arrow::before {
        -moz-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        -webkit-transform: rotate(45deg);
        transform: rotate(45deg);
        -moz-border-radius-topright: 3px;
        -webkit-border-top-right-radius: 3px;
        border-top-right-radius: 3px;
        -moz-border-radius-bottomright: 3px;
        -webkit-border-bottom-right-radius: 3px;
        border-bottom-right-radius: 3px;
        left: 26px;
    }
</style>